import {
    ACCORDION_CANCEL_UPDATE
} from './actionTypes';

export function hideForm() {
    return {
        type: ACCORDION_CANCEL_UPDATE
    }
};